module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/cover-1-07c235a7184c2d11b47b0f7a0869f282.webp";